import AbstractView from 'abstract';
import Vue from 'vue'
import CompareTableInit from 'initializations/pages/CompareTable'
import SidebarInit from 'initializations/Sidebar'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        SidebarInit.init("sidebar")
        CompareTableInit.init("compareTable")

        const CompareTablePage = () => import(/* webpackChunkName: "compare-table-page" */ 'containers/Pages/CompareTable')

        new Vue({
            el: "#" + this.elemId,
            store,
            render: h => h(CompareTablePage)
        })
    }
}
